import { AREA_ID_DOMESTIC, INSURANCE } from '@/constants';
import { Area, CountryCode, ProductCode } from '@/enums';
import { getCountryCode } from './CountryCodeHelper';
import { getRoute } from './RouteHelper';

export const getAreaName = (areaId: number) => {
  return areaId == AREA_ID_DOMESTIC ? Area.Domestic : Area.International;
};

export const getProductCode = () => {
  const countryCode = getCountryCode();
  const { entity } = getRoute(window.location.pathname);

  return {
    [CountryCode.Malaysia]:
      entity === INSURANCE ? ProductCode.EGIB : ProductCode.EGTB,
    [CountryCode.Philippines]: ProductCode.ELGAP,
  }[countryCode];
};

export const getProductNameGA = () => {
  const countryCode = getCountryCode();
  return {
    [CountryCode.Malaysia]: 'TripCare 360',
    [CountryCode.Philippines]: 'Travel 360',
  }[countryCode];
};

export const getItemNameGA = () => {
  const countryCode = getCountryCode();
  return {
    [CountryCode.Malaysia]: 'tripcare_360',
    [CountryCode.Philippines]: 'travel_360',
  }[countryCode];
};
